import type { AssetTypeSeverityGridTabProps } from "@/modules/asset-type/asset-type-severity-grid-tab/asset-type-severity-grid-tab.type";

import SeverityGridEditor from "@/components/AssetType/SeverityGridEditor";
import { AssetTypeSaveBar } from "@/modules/asset-type/asset-type-save-bar";
import { useAssetTypeSeverityGrid } from "@/modules/asset-type/asset-type-severity-grid-tab/asset-type-severity-grid-tab.hook";

const AssetTypeSeverityGridTab = ({
  assetType,
  loading,
}: AssetTypeSeverityGridTabProps) => {
  const {
    defectTree,
    onUpdateDefectTree,
    translation,
    onUpdateTranslation,
    handleCancel,
    handleSave,
    lastUpdatedAt,
    loading: mutationLoading,
  } = useAssetTypeSeverityGrid(assetType);
  return (
    <>
      <AssetTypeSaveBar
        lastUpdatedAt={lastUpdatedAt}
        onSave={handleSave}
        onCancel={handleCancel}
        loading={mutationLoading || loading}
      />
      <SeverityGridEditor
        assetTypeId={assetType?.id}
        loading={loading}
        defectTree={defectTree ?? {}}
        translation={translation}
        onUpdateDefectTree={onUpdateDefectTree}
        onUpdateTranslation={onUpdateTranslation}
      />
    </>
  );
};

export default AssetTypeSeverityGridTab;
